import { push } from 'connected-react-router'
import { Action } from 'redux-actions'
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { msgid, ngettext, t } from 'ttag'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { ROUTES } from '../../../common/Routes/routePaths'
import api from '../../../services/api.services'
import {
  DeleteUser$Request,
  GetCompanySignUpCode$Request,
  GetSpecificCompanyUsers$Request,
  SetUserCountry$Request,
  SetUserDivision$Request,
  ToggleUserStatus$Request,
} from '../../../services/api.types'
import {
  //createUser,
  deleteUser,
  getCompanySignUpCode,
  getCompanySignUpCodeSuccess,
  getCompanyUsers,
  getCompanyUsersFail,
  getCompanyUsersSuccess,
  setUserCountry,
  setUserDivision,
  toggleUserStatus,
} from './UserManagementActions'
import { getErrorMsg } from '../../../common/helpers/translations'

function* sagaGetCompanyUsers(action: Action<GetSpecificCompanyUsers$Request>) {
  try {
    const { companyUsers } = yield call(api.users.getSpecificCompanyUsers, action.payload)
    yield put({ type: String(getCompanyUsersSuccess), payload: companyUsers })
  } catch (e: any) {
    console.log('GetCompanyUsersFailed: ', e)
    yield put({ type: String(getCompanyUsersFail) })
  }
}

/*function* sagaCreateUser(action: Action<string[]>) {
  try {
    const emails = action.payload
    const { userDto } = yield api.auth.whoAmI()
    const { companyId } = userDto
    yield api.auth.createUser({ emails, lang: userDto.lang, companyId })

    const notification: INotification = {
      type: 'success',
      content: ngettext(
        msgid`User successfully created`,
        `Successfully created ${action.payload.length} users`,
        action.payload.length,
      ),
    }

    yield put(push(ROUTES.ADMIN_USER.to, { notification }))
  } catch (e: any) {
    const notification: INotification = {
      type: 'warning',
      content: getErrorMsg('user creation'),
    }

    yield put({ type: String(addNotification), payload: notification })
  }
}*/

function* sagaDeleteUser(action: Action<DeleteUser$Request>) {
  try {
    yield api.users.deleteUser(action.payload)

    const { companyId } = action.payload
    yield put({ type: String(getCompanyUsers), payload: { companyId } })

    const deleteSucessNotification: INotification = {
      type: 'success',
      content: t`User successfully deleted`,
    }

    yield put({ type: String(addNotification), payload: deleteSucessNotification })
  } catch (e: any) {
    const deleteFailsNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user deletion'),
    }

    yield put({ type: String(addNotification), payload: deleteFailsNotification })
  }
}

function* sagaToggleUserStatus(action: Action<ToggleUserStatus$Request>) {
  try {
    yield api.users.toggleUserStatus(action.payload)
    yield put({ type: String(getCompanyUsers), payload: { companyId: action.payload.companyId } })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user status change'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaSetUserCountry(action: Action<SetUserCountry$Request>) {
  try {
    yield api.users.setUserCountry(action.payload)
    yield put({ type: String(getCompanyUsers), payload: { companyId: action.payload.companyId } })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user country change'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaSetUserDivision(action: Action<SetUserDivision$Request>) {
  try {
    yield api.users.setUserDivision(action.payload)
    yield put({ type: String(getCompanyUsers), payload: { companyId: action.payload.companyId } })
  } catch (e: any) {
    const toggleErrorNotification: INotification = {
      type: 'warning',
      content: getErrorMsg('user group change'),
    }

    yield put({ type: String(addNotification), payload: toggleErrorNotification })
  }
}

function* sagaGetCompanySignUpCode(action: Action<GetCompanySignUpCode$Request>) {
  try {
    const { signUpCode } = yield call(api.users.getCompanySignUpCode, action.payload)
    yield put({
      type: String(getCompanySignUpCodeSuccess),
      payload: { signUpCode, companyId: action.payload.companyId },
    })
  } catch (e: any) {
    console.log('GetCompanySignUpCode: ', e)
  }
}

export function* userManagementSagas() {
  yield all([
    takeEvery(String(getCompanyUsers), sagaGetCompanyUsers),
    //takeEvery(String(createUser), sagaCreateUser),
    takeEvery(String(deleteUser), sagaDeleteUser),
    takeEvery(String(toggleUserStatus), sagaToggleUserStatus),
    takeEvery(String(setUserCountry), sagaSetUserCountry),
    takeEvery(String(setUserDivision), sagaSetUserDivision),
    takeEvery(String(getCompanySignUpCode), sagaGetCompanySignUpCode),
  ])
}
